// @ts-nocheck

export default {
  API_URL: window.__API_URL__ || import.meta.env.VITE_API_URL,
  SOCKET_URL: window.__SOCKET_URL__ || import.meta.env.VITE_SOCKET_URL,
  OSS_ACCESS_KEY: window.__OSS_ACCESS_KEY__ || import.meta.env.VITE_OSS_ACCESS_KEY,
  STATIC_FILE_PATH: window.__STATIC_FILE_PATH__ || import.meta.env.VITE_STATIC_FILE_PATH,
  REDBOOK_AD_URL: window.__REDBOOK_AD_URL__ || import.meta.env.VITE_REDBOOK_AD_URL,
  DISABLE_REGISTER: window.__DISABLE_REGISTER__,
  MCP_CLIENT_URL: window.__MCP_CLIENT_URL__ || import.meta.env.VITE_MCP_CLIENT_URL,
  TEMPLATE_EDITABLE_ENT_IDS: window.__TEMPLATE_EDITABLE_ENT_IDS__,
  ORG_ID: window.__ORG_ID__ || import.meta.env.VITE_ORG_ID,
};
